import React from "react";
import PropTypes from "prop-types";
import Select from 'react-select';

import "./DropdownSchw.css";

class DropdownSchw extends React.Component {

  static propTypes = {
    options: PropTypes.array.isRequired,
    block: PropTypes.bool,
    handleChange: PropTypes.func
  };

  static defaultProps = {
    block: false
  };


  render() {

    const { options, block, handleChange, ...remainingProps } = this.props;

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            fontSize:'16px',
            fontWeight: 'normal',
            color:'black',
            lineHeight:'24px'


        }),
        option: (provided, state) => ({
            ...provided,
            //height:'20px',
            padding:'0 10px',
            color: state.isSelected ? 'black' : state.isFocused ? 'white' : 'black',
            backgroundColor: state.isFocused ? '#00a0df' : 'white',
            "&:hover": {
                color:'white',
                backgroundColor:'#00a0df'
            }

        }),
        placeholder: (provided, state) => ({
            ...provided,
            color:'black',
        }),
        menu: (provided, state) => ({
            ...provided,
            marginTop:0,
        }),
        menuList: (provided, state) => ({
            ...provided,
            height:'200px'
        }),
        control: (base, state) => ({
            ...base,
            color:'black',
            fontSize:'18px',
            borderWidth:'1.5px',
            borderColor:'grey',
            //border: state.isFocused ? 0 : 0,
            boxShadow: state.isFocused ? 0 : 0,
            "&:hover": {
                //border: state.isFocused ? 0 : 0
            }
        })

    }
    return (

        <Select
            name={this.props.drop}
            value={this.props.drop}
            isSearchable={false}
            aria-label="Select Month"
            placeholder={this.props.monthDate.toString()}
            onChange={e => {
                handleChange(e.val, "dropdown");
            }}

            styles={customStyles}
            options={options}
        />
    );
  }
}

export default DropdownSchw;
